import { getAdvancementTypeTranslation } from '@shared/localization';
import { normalizeAdvancementType } from '@shared/utils';

export default (advancementName: string, advancementType: string) => {
  const normalizedAdvancementType = normalizeAdvancementType(advancementType);
  const advancementTypeLabel = getAdvancementTypeTranslation(
    normalizedAdvancementType,
  );
  return `${advancementTypeLabel}: ${advancementName}`;
};
